export default "__VITE_ASSET__iBrTEABL__"